"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTextContent = exports.TextContent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _basis = require("basis");

var _reactRenderMarkup = require("react-render-markup");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
// @ts-ignore
var replace = {
  a: function a(props) {
    var newTab = props.target === '_blank';
    return /*#__PURE__*/_react.default.createElement(_basis.Link, (0, _extends2.default)({}, props, {
      newTab: newTab
    }));
  },
  p: _basis.Text,
  em: 'strong',
  b: 'strong'
};

var TextContent = function TextContent(props) {
  var path = props.path,
      vars = props.vars;
  var content = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.content;
  });
  var value = (0, _react.useMemo)(function () {
    return (0, _get2.default)(content, path, '');
  }, [content, path]);
  var string = vars ? (0, _utils.replaceStringVars)(value, vars) : value;
  return (0, _reactRenderMarkup.renderMarkup)(string, {
    replace: replace
  });
};

exports.TextContent = TextContent;

var useTextContent = function useTextContent(path, vars) {
  var content = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.config.content;
  });
  var value = (0, _react.useMemo)(function () {
    return path ? (0, _get2.default)(content, path, '') : '';
  }, [content, path]);
  return vars ? (0, _utils.replaceStringVars)(value, vars) : value;
};

exports.useTextContent = useTextContent;